import React, { Fragment } from "react";
import { connect } from "react-redux";

import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import { DialogContent, DialogActions, Button, CircularProgress } from "@material-ui/core";
import CheckIcon from '@material-ui/icons/Check';

import styled from "styled-components";

import { fetchDealsNames } from "store/state/deal";
import { GridListSelection } from "./GridListSelection";
import { DynamicStepper } from "./DynamicStepper";
import dealStatuses from "constants/dealStatuses";
import { downloadDealPdf } from '../../../store/state/deal';

const styles = {
  active: {
    color: "#2196f3 !important"
  },
  completed: {
    color: "#2196f3 !important"
  }
};

const Description = styled.div`
  color: rgba(0, 0, 0, 0.537);
  padding-bottom:20px;
`;

const allowedStatuses = [dealStatuses.CLOSED, dealStatuses.REFINANCE, dealStatuses.ADDING_SUPPLEMENTAL, dealStatuses.MODIFYING];

class DealExportDialog extends React.Component {
  state = {
    deals: []
    , activeStep: 0
    , selectedDeals: []
    , hasInitialized: false
  }

  componentWillMount() {
    this.props.fetchDealsNames();
  }

  componentDidUpdate() {
    if(!this.state.hasInitialized) {
      let deals = [...this.props.deals];
      deals = deals.filter(deal => allowedStatuses.indexOf(deal.dealStatusId) >= 0);
  
      this.setState({
        deals
        , selectedDeals: deals
        , hasInitialized: true
      })
    }
  }

  // grid list items

  onToggleDeal = (item) => this.isItemSelected(item) ? this.removeDeal(item) : this.addDeal(item);
  isItemSelected = ({ id }) => this.state.selectedDeals.findIndex(item => item.id === id) >= 0;

  addDeal = (deal) => {
    const selectedDeals = [...this.state.selectedDeals];
    selectedDeals.push(deal);
    this.setState({ selectedDeals });
  }

  removeDeal = (deal) => {
    const selectedDeals = [...this.state.selectedDeals];
    const index = selectedDeals.findIndex(item => item.id === deal.id);
    selectedDeals.splice(index, 1);

    this.setState({ selectedDeals });
  }

  getGridList = () => (
    <GridListSelection
      style={{ maxHeight: 500, margin: 0 }}
      items={this.state.deals}
      display={(item) => item.name}
      cellHeight={40}
      cols={3}
      spacing={4}
      isSelected={(item) => this.isItemSelected(item)}
      onToggle={(item) => this.onToggleDeal(item)}
    />
  )

  // download/spinner

  getDownLoadStep = () => {
    if (this.props.isLoading) {
      return (
        <div style={{ width: "100%", textAlign: "center", marginTop: "30px", fontSize: "16pt" }}>
          <CircularProgress size={120} thickness={1} />
        </div>
      )
    }

    return (
      <div style={{ width: "100%", textAlign: "center", marginTop: "30px", fontSize: "16pt" }}>
        <CheckIcon style={{ width: '5em', height: '5em' }} color='primary' />
        <Description>All Done! Your Deal Summary export has begun.</Description>
      </div>
    )
  }

  // stepper

  closeModal = () => this.props.onClose();

  steps = [
    {
      id: 1,
      label: 'Select Deals'
    }
    , {
      id: 2,
      label: 'Download'
    }
  ];

  setStep = (activeStep) => this.setState({ activeStep });

  getStepContent = () => {
    const { activeStep } = this.state;
    switch (activeStep) {
      case 0:
        return this.getGridList();

      case 1:
        return this.getDownLoadStep();
    }
  }

  onGeneratePdf = () => {
    this.setStep(1);
    const dealIds = this.state.selectedDeals.map(x => x.id);
    this.props.downloadDealPdf({ dealIds });
  }

  render() {
    const { activeStep } = this.state;

    return (
      <Fragment>
        <Dialog
          open={!!this.state.selectedDeals.length}
          onClose={this.closeModal}
          maxWidth="md"
          fullWidth

          id="dealExportDialog">
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <DialogTitle>Deal Summary Export</DialogTitle>
            <IconButton style={{ marginRight: 16 }} onClick={this.closeModal} id="exitCustomizePreferences">
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>

          <DialogContent>
            <Description>Select the deals you would like to export</Description>

            <DynamicStepper
              activeStep={activeStep}
              steps={this.steps}
            />

            {this.getStepContent()}
          </DialogContent>

          <DialogActions>
            {activeStep === 0 && (
              <div style={{ justifyContent: 'space-between', display: 'flex', flex: '1 0 auto' }}>
                <div style={{ padding: '8px 16px' }}>
                  {this.state.selectedDeals.length} / {this.state.deals.length} Selected
              </div>
                <Button onClick={this.onGeneratePdf} color="primary">GENERATE PDF</Button>
              </div>
            )}
            {activeStep === 1 && <Button onClick={this.closeModal} color="primary">DONE</Button>}
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ deal }) => ({
  deals: deal.dealsNames,
  isLoading: deal.isLoading
})

export default connect(mapStateToProps, {
  fetchDealsNames
  , downloadDealPdf
})(withStyles(styles)(DealExportDialog));
